import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import { formatNumber } from "@cinch-labs/shared-util";
import { Wrapper } from "@cinch-nx/shared-ui";
import TrustpilotStars from "../trustpilot-overview/stars/stars";
import TrustpilotLogo from "./assets/trustpilot-logo.svg";
import styles from "./trustpilot-score.module.css";
var TRUSTPILOT_URL = "https://uk.trustpilot.com/review/cinch.co.uk";
export function TrustpilotScore(param) {
    var numberOfReviews = param.numberOfReviews, starRating = param.starRating, starRatingLabel = param.starRatingLabel, className = param.className;
    return /*#__PURE__*/ _jsx(Wrapper, {
        className: {
            container: className
        },
        children: /*#__PURE__*/ _jsx("a", {
            href: TRUSTPILOT_URL,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles["container"],
                children: [
                    /*#__PURE__*/ _jsxs(Text, {
                        children: [
                            "Check out our ",
                            /*#__PURE__*/ _jsx("b", {
                                children: formatNumber(numberOfReviews)
                            }),
                            " reviews"
                        ]
                    }),
                    /*#__PURE__*/ _jsx(TrustpilotStars, {
                        className: styles["trustpilotStars"],
                        starRatingLabel: starRatingLabel,
                        starRating: starRating
                    }),
                    /*#__PURE__*/ _jsx(TrustpilotLogo, {
                        className: styles["trustpilotLogo"]
                    })
                ]
            })
        })
    });
}
export default TrustpilotScore;
